import { render, staticRenderFns } from "./NewFaults.vue?vue&type=template&id=14f3f991&scoped=true&"
import script from "./NewFaults.vue?vue&type=script&lang=js&"
export * from "./NewFaults.vue?vue&type=script&lang=js&"
import style0 from "./NewFaults.vue?vue&type=style&index=0&id=14f3f991&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f3f991",
  null
  
)

export default component.exports